import { useQuery } from '@tanstack/react-query';
import { httpsCallable } from 'firebase/functions';
import { functions } from '@util/firebase';

export const useCustomerSession = () => {
  const customerSessionQuery = useQuery({
    queryKey: ['customerSession'],
    queryFn: async () =>
      await httpsCallable<void, string | null>(
        functions,
        'v2_getCustomerSession'
      )(),
  });
  return customerSessionQuery;
};
